import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@/composables/useApi';

export const InspectionStatuses = {
  Requested: 0,
  Approved: 1,
  Rejected: 2,
  Planned: 3,
};

export const useInspectionStore = defineStore('inspectionStore', () => {
  const inspection = ref();
  const { apiGet } = useApi();

  async function getInspectionByID(id, source) {
    let url = 'inspections/';
    switch (source) {
      case 'order':
        url += `orders/${id}`;
        break;
      case 'invoice':
        url += `invoices/${id}`;
        break;
    }

    const data = await apiGet(url);
    inspection.value = responseToInspection(data);
  }

  function responseToInspection(responseInspection) {
    let inspection = {};
    inspection.keurderJobId = responseInspection.keurderJobId;
    inspection.inspectionDate = responseInspection.keuringAppointmentDate;
    inspection.approvedDate = responseInspection.approvedDate;

    inspection.status = InspectionStatuses.Requested;
    if (responseInspection.askedKeuring) {
      inspection.status = InspectionStatuses.Requested;
    }
    if (responseInspection.keuringAppointment) {
      inspection.status = InspectionStatuses.Planned;
    }
    if (responseInspection.approved) {
      inspection.status = InspectionStatuses.Approved;
    }
    inspection.articles = responseInspection.articles;
    return inspection;
  }

  return {
    inspection,
    getInspectionByID,
  };
});
